import styles from './styles';

import React from 'react';

import { computed } from 'mobx';
import { observer } from 'mobx-react';

import moment from 'moment';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { PrePaidStatus } from 'tm3-core/api.dtos';
import type { CustomerSubscriptionResponse } from 'tm3-core/api.dtos';

interface IProps extends WithStyles<typeof styles> {
  pkg: CustomerSubscriptionResponse;
}

@observer
class SubscriptionDetails extends React.Component<IProps> {
  render() {
    const { subscriptionContainer } = this.props.classes;
    const { validForDaysFromPurchase, earliestAllowedCancellationDate } = this.props.pkg;

    return (
      <div className={subscriptionContainer}>
        <hr />
        <div>Valid for {validForDaysFromPurchase} days</div>
        <div>{this.subscriptionPeriod}</div>
        <div>{this.minimumTerm}</div>
        <div>{this.maximumTerm}</div>
        {!!this.displayMinTerm && (
          <div>{`Minimum term ends: ${moment(earliestAllowedCancellationDate).format(
            'DD/MM/YYYY'
          )}`}</div>
        )}
      </div>
    );
  }

  @computed
  private get displayMinTerm(): boolean {
    const { status, earliestAllowedCancellationDate } = this.props.pkg;
    return (
      status === PrePaidStatus.Active && new Date(earliestAllowedCancellationDate) > new Date()
    );
  }

  @computed
  private get subscriptionPeriod(): string | null {
    const { subscriptionInterval, subscriptionIntervalUnit } = this.props.pkg;

    const intervalUnit = subscriptionIntervalUnit?.toLocaleLowerCase() + '(s)';

    return `This subscription will renew every ${subscriptionInterval} ${intervalUnit}`;
  }

  @computed
  private get minimumTerm(): string | null {
    const { hasMinimumTerm, minimumTermInterval, minimumTermIntervalUnit } = this.props.pkg;

    if (!hasMinimumTerm) {
      return null;
    }

    const intervalUnit = minimumTermIntervalUnit.toLocaleLowerCase() + '(s)';

    return `Signing up to this will be for a minimum of ${minimumTermInterval} ${intervalUnit}`;
  }

  @computed
  private get maximumTerm(): string | null {
    const { hasMaximumTerm, maximumTermInterval, maximumTermIntervalUnit } = this.props.pkg;

    if (!hasMaximumTerm) {
      return null;
    }

    const intervalUnit = maximumTermIntervalUnit.toLocaleLowerCase() + '(s)';

    return `This will continue to renew for ${maximumTermInterval} ${intervalUnit} and then expire`;
  }
}

export default withStyles(styles)(SubscriptionDetails);
